import { useState } from 'react';

export default function InputTextarea({
  label,
  inputId,
  placeholder,
  value = '',
  setValue = '',
  required = false,
  isValid,
  setIsValid = () => {},
  showErrors = false,
}) {
  const [validText, setValidText] = useState('');
  const [touched, setTouched] = useState(false);

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-[minmax(160px,1fr)_minmax(0,3fr)_minmax(160px,1fr)] gap-2 md:gap-4 items-center mb-2 mt-4">
      <label htmlFor={inputId} className="text-explorer font-semibold text-base">
        {label} <span className="text-giver align-middle">{required ? '*' : ''}</span>
      </label>
      <textarea
        id={inputId}
        type="text"
        placeholder={placeholder}
        rows={10}
        className="min-w-0 w-full rounded-lg py-1 px-3 resize-none"
        value={value}
        onBlur={() => {
          setTouched(true);
          if (required && !value.trim()) setValidText('필수 입력값입니다.');
        }}
        onChange={async (e) => {
          setValue(e.target.value);

          if (e.target.value.trim()) {
            return setIsValid(true);
          }

          setIsValid(false);
        }}
      />
      <span className="text-red-400 text-sm">{(touched || showErrors) && required && !value.trim() ? (validText || '필수 입력값입니다.') : ''}</span>
    </div>
  );
}
